import type {TimeZone} from '@hconnect/common/types'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE, LOCATION_STATUS_DEFAULT_TIME_RANGE} from '../consts'
import {getLocationStatusQuickSelectionItems, parseTimeRangeParamToDateRange} from '../utils'

import {useLocationStatusPageParams} from './useLocationStatusPageParams'

type UseDateRangeParams = {
  timezone: TimeZone
}

export const useLocationStatusDateRange = ({timezone}: UseDateRangeParams) => {
  const {timeRangeParam} = useLocationStatusPageParams()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const selectionItems = useMemo(
    () => getLocationStatusQuickSelectionItems(t, timezone),
    [t, timezone]
  )

  return useMemo(
    () =>
      parseTimeRangeParamToDateRange({
        timeRange: timeRangeParam,
        timezone,
        selectionItems,
        defaultSelectionId: LOCATION_STATUS_DEFAULT_TIME_RANGE
      }),
    [timeRangeParam, timezone, selectionItems]
  )
}
